package gr.tech.GRAttestation.infrastructure.validations

import gr.tech.GRAttestation.util.Constants

fun validateEmail(email: String): String = when {
    email.isBlank() -> "Email is required."
    email.length < Constants.VALIDATIONS.EMAIL_MIN_LENGTH ->
        "Email must be at least ${Constants.VALIDATIONS.EMAIL_MIN_LENGTH} characters."
    email.length > Constants.VALIDATIONS.EMAIL_MAX_LENGTH ->
        "Email must be under ${Constants.VALIDATIONS.EMAIL_MAX_LENGTH} characters."
    !Constants.VALIDATIONS.EMAIL_REGEX.matches(email.trim()) ->
        "Enter a valid email address."
    else -> ""
}

fun validateName(value: String, fieldName: String): String = when {
    value.isBlank() -> "$fieldName is required."
    value.trim().length < Constants.VALIDATIONS.NAME_MIN_LENGTH -> "$fieldName is too short."
    value.trim().length > Constants.VALIDATIONS.NAME_MAX_LENGTH ->
        "$fieldName must be under ${Constants.VALIDATIONS.NAME_MAX_LENGTH} characters."
    else -> ""
}

fun validatePassword(password: String): String = when {
    password.isBlank() -> "Password is required."
    password.length < Constants.VALIDATIONS.PASSWORD_MIN_LENGTH ->
        "Password must be at least ${Constants.VALIDATIONS.PASSWORD_MIN_LENGTH} characters."
    password.length > Constants.VALIDATIONS.PASSWORD_MAX_LENGTH ->
        "Password must be under ${Constants.VALIDATIONS.PASSWORD_MAX_LENGTH} characters."
    else -> ""
}

fun validateConfirmPassword(password: String, confirmPassword: String): String = when {
    confirmPassword.isBlank() -> "Please confirm your password."
    confirmPassword != password -> "Passwords do not match."
    else -> ""
}

fun validateConfirmEmail(email: String, confirmEmail: String): String = when {
    confirmEmail.isBlank() -> "Please confirm your email."
    confirmEmail.trim().lowercase() != email.trim().lowercase() -> "Emails do not match."
    else -> ""
}
